import React, { useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { dateCharacters } from 'utils/constants'
import { default as DayPickerInput } from 'react-day-picker/DayPickerInput'
import MomentLocaleUtils, {
  formatDate,
  parseDate
} from 'react-day-picker/moment'
import 'react-day-picker/lib/style.css'
import 'styles/d3/datepicker.scss'

const FixedDayPickerInput = DayPickerInput.default

const DatePicker = React.forwardRef(
  (
    {
      className,
      date,
      disabled,
      disabledDays,
      id,
      initialDate,
      onDayChange,
      onEnterPress,
      selectedLocale
    },
    ref
  ) => {
    const [valid, setValid] = useState(true)
    const [initialValue, setInitialValue] = useState(
      initialDate ? initialDate.toDate() : ''
    )
    const value = date ? date.toDate() : initialValue

    // moment().locale(undefined) returns a string (abbr), not a Moment — breaks .localeData().
    const localeKey = selectedLocale || 'en'
    const localizedDateFormat = moment()
      .locale(localeKey)
      .localeData()._longDateFormat.L

    const handleBlur = () => {
      if (valid) {
        setInitialValue(initialDate ? initialDate.toDate() : '')
      }
    }

    return (
      <FixedDayPickerInput
        inputProps={{
          className: `${className} ${valid ? '' : 'invalid-date'}`,
          disabled,
          id,
          onBlur: handleBlur,
          // readOnly: true, TODO: potentially utilize this in the future to prevent manual string entry
          onKeyPress: e => {
            if (e.key === 'Enter') {
              e.preventDefault()
              if (onEnterPress) onEnterPress()
            }
            if (!dateCharacters.includes(e.key)) e.preventDefault()
          },
          ref
          // type: 'date', // TODO: use to show native datepicker on mobile devices
        }}
        format={localizedDateFormat}
        formatDate={(_date, format, locale) =>
          formatDate(_date, localizedDateFormat, localeKey)
        }
        parseDate={(str, format) => {
          const parsedDate = parseDate(str, format)
          if (parsedDate && !valid) setValid(true)
          else if (!parsedDate && valid) setValid(false)
          return parsedDate
        }}
        dayPickerProps={{
          disabledDays,
          locale: localeKey,
          localeUtils: MomentLocaleUtils,
        }}
        onDayChange={_date => {
          if (_date) onDayChange(moment(_date))
          else onDayChange(_date) // this allows for blank dates and doesn't default to present date when date is cleared
        }}
        value={value}
        placeholder={localizedDateFormat}
      />
    )
  }
)

DatePicker.propTypes = {
  className: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(moment)]),
  disabled: PropTypes.bool,
  disabledDays: PropTypes.any,
  id: PropTypes.string,
  initialDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(moment)
  ]),
  onDayChange: PropTypes.func,
  onEnterPress: PropTypes.func,
  selectedLocale: PropTypes.string
}

export default DatePicker
